// generated file
// generated file
// generated file

// @ts-ignore
import styles from "./theme-with-colors-replaced.css";
import cssVariales from "./theme-variables";
import * as React from "react";
import { unuseCSs, useCss } from "../../themeChangeSync";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";

export default (props) => {
  React.useLayoutEffect(() => {
    useCss(() => {
      console.log("Loaded theme lara-light-purple");
      styles.use();
    });

    return () => {
      unuseCSs(() => {
        styles.unuse();
      });
    };
  }, []);

  return <StyledComponentsThemeProvider {...props} theme={cssVariales} />;
};
